export default class Current {

	constructor(node) {
    this.node = node;
    this.init();
	}

  init() {
    const elements =  Array.from(this.node.children)
    this.currentItem = elements.splice(-1)[0];
    this.items = elements.slice(0, -1);
  }
}
